import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyBmPoRe8D5aJa6Iw6yoXJH7g8Jg7DjrkJU",
  authDomain: "hestia-eficiencia-energetica.firebaseapp.com",
  projectId: "hestia-eficiencia-energetica",
  storageBucket: "hestia-eficiencia-energetica.appspot.com",
  messagingSenderId: "188905489292",
  appId: "1:188905489292:web:7feb06a8e373bbdb2b0ca9"
};
// Inicializador de Firebase
firebase.initializeApp(firebaseConfig);

const db = firebase.firestore()
const auth = firebase.auth()
const storage = firebase.storage();

export { db, auth, storage }